(function () {
  function copyPreviewParams(destination) {
    var current = new URL(window.location.href);

    ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
      if (current.searchParams.has(key) && !destination.searchParams.has(key)) {
        destination.searchParams.set(key, current.searchParams.get(key));
      }
    });

    return destination;
  }

  function navigatePreservingPreview(href) {
    if (!href) return;

    var destination = copyPreviewParams(new URL(href, window.location.origin));
    window.location.assign(destination.toString());
  }

  function initBarrosBrandRouting() {
    document.querySelectorAll('[data-barros-route]').forEach(function (link) {
      if (link.dataset.barrosRouteReady === 'true') return;
      link.dataset.barrosRouteReady = 'true';

      link.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        var href = link.getAttribute('href');
        if (!href) return;

        event.preventDefault();
        navigatePreservingPreview(href);
      });
    });

    document.querySelectorAll('[data-barros-scroll]').forEach(function (link) {
      if (link.dataset.barrosScrollReady === 'true') return;
      link.dataset.barrosScrollReady = 'true';

      link.addEventListener('click', function (event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        var href = link.getAttribute('href') || '';
        var fallback = link.getAttribute('data-barros-fallback');
        var target = null;

        if (href.charAt(0) === '#') {
          try {
            target = document.querySelector(href);
          } catch (error) {
            target = null;
          }
        }

        event.preventDefault();
        event.stopPropagation();

        if (target) {
          var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({
            behavior: reduceMotion ? 'auto' : 'smooth',
            block: 'start'
          });

          if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', href);
          }
          return;
        }

        if (fallback) {
          navigatePreservingPreview(fallback);
        }
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBarrosBrandRouting);
  } else {
    initBarrosBrandRouting();
  }
})();